import { create } from "zustand";

type ProgressState = {
  progress: Record<string, number>; // 업로드 키 → 진행률
  setProgress: (key: string, percent: number) => void;
  clearProgress: (key: string) => void;
};

export const useUploadProgress = create<ProgressState>((set) => ({
  progress: {},
  setProgress: (key, percent) =>
    set((state) => ({
      progress: {
        ...state.progress,
        [key]: percent,
      },
    })),
  clearProgress: (key) =>
    set((state) => {
      const copy = { ...state.progress };
      delete copy[key];
      return { progress: copy };
    }),
}));

